export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10464.646d9252.jpg";